module.exports = __webpack_public_path__ + "static/media/shuzhihua4.bc5b9dd4.png";